import React from "react";
import { useTranslation } from "react-i18next";

const ChangeContent = ({ content, title }) => {
  const { t } = useTranslation();
  return (
    <>
      {title === t('ChangeContent_title_supplies', '장루주머니 교환할 때 필요한 물품은 무엇인가요?') ? (
        <div>
          <p>{content}</p>
          <p>{t('ChangeContent_skin_barrier', '- 피부보호판(Skin Barrier)')}</p>
          <p>{t('ChangeContent_colostomy_pouch', '- 장루주머니(Colostomy Pouch)')}</p>
          <p>{t('ChangeContent_protective_film', '- 피부보호 필름(Protective Film)')}</p>
          <p>{t('ChangeContent_barrier_paste', '- 피부보호 연고(Protective Barrier Paste)')}</p>
          <p>{t('ChangeContent_curved_scissors', '- 곡가위')}</p>
          <p>
            {t('ChangeContent_other_items', '- 기타 : 매직펜(혹은 볼펜), 자(Stoma Guide), 휴지, 방수포, 반창고, 비닐주머니, 거즈나 작은 수건(젖은 것과 마른 것) 등 자세한 내용은 오스토케어 앱의 <장루교체방법 > 영상을 통해 배우실 수 있습니다.')}
          </p>
        </div>
      ) : (
        <div>
          <p>{content}</p>
          <p>{t('ChangeContent_source_severance', '- 세브란스 장루요루전문관리팀. 장루, 요루관리')}</p>
          <p>{t('ChangeContent_source_cancer_school', '- 암스쿨')}</p>
          <p>{t('ChangeContent_source_cancer_answer', '- 캔서앤서')}</p>
          <p>{t('ChangeContent_source_samsung', '- 삼성창원병원')}</p>
          <p>{t('ChangeContent_source_coloplast', '- Coloplast')}</p>
          <p>{t('ChangeContent_source_seoul', '- 서울대병원 장루간호팀')}</p>
        </div>
      )}
    </>
  );
};
{
}
export default ChangeContent;
